<template>
  <div id="app aggregated">
    <div v-if="!loaded" class="loader">
      <div class="loading loading-lg"></div>
    </div>

    <template v-else>

      <div class="form-horizontal columns">
        <div class="form-group column col-5">
          <div class="col-4 col-sm-12">
            <label class="form-label" for="groupby-filter">Aggregate Fandom</label>
          </div>
          <div class="col-8 col-sm-12">
            <select id="groupby-filter" class="form-select" v-model="groupBy">
              <option v-for="gbo in groupByOptions" :value="gbo.tag" :key="gbo.display" :selected="gbo.tag == groupBy">
                {{ gbo.display }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group column col-5">
          <div class="col-4 col-sm-12">
            <label class="form-label" for="fandom-filter">Filter </label>
          </div>
          <div class="col-8 col-sm-12">
            <input class="form-input" type="text" id="fandom-filter" placeholder="Search fandom name..."
              v-model="filter" />
          </div>
        </div>

        <label class="ml-2 form-switch form-inline">
          <input type="checkbox" v-model="options.useToggles" />
          <i class="form-icon"></i> Use toggles for prompt text
        </label>
        <label class="form-switch form-inline">
          <input type="checkbox" v-model="options.truncateTags" />
          <i class="form-icon"></i> Use toggles for 15+ tags
        </label>
      </div>
      <pagination :pagination="pagination" @page="page"></pagination>

      <div v-if="updating" class="loader">
        <div class="loading loading-lg"></div>
      </div>

      <div class="toast toast-error" v-if="!updating && !processing">
        This is an <strong>experimental page</strong> that lists requests from all scraped exchanges for users who
        have opted into
        <strong>an aggregate fandom</strong> (either Creator's Choice of Previously Requested Fandom or Any Fandom I've
        Requested Before) for this exchange, grouped by fandom.
      </div>

      <aggregated-fandom-table :processing="processing" :updating="updating" :filtered="filtered"
        :aggregatetag="groupBy"></aggregated-fandom-table>

      <div class="mt-2" v-if="!updating && !processing && allOptions.length && !filtered.length">
        Either nothing matches your filters or this exchange can't be grouped using the current
        Group By filter ({{ options.groupBy }}) you're on ): Change the Group By option using the
        dropdown above, or you could try searching
        <router-link :to="`/${exchangeId}/all`">All Requests</router-link>
        instead.
      </div>
      <pagination :pagination="pagination" @page="page"></pagination>
    </template>
  </div>
</template>

<script>
import AggregatedFandomTable from "../components/aggregatedFandomTable.vue";
import Pagination from "../components/pagination.vue";
import utils from "../components/utils.js";
import tableResizer from "../directives/tableResizer";
// third party
import { map, filter, slice, each, includes } from "lodash-es";
import { mapGetters } from "vuex";
import axios from "axios";
String.prototype.hashCode = function () {
  var hash = 0,
    i, chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr = this.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}
export default {
  name: "aggregated",
  components: {
    Pagination,
    AggregatedFandomTable
  },
  beforeMount() {
    this.$store.commit("setAggregatedPrompts", {});
    this.$store.commit("setPrompts", {});
    this.$store.commit("setFandoms", []);
    this.$store.commit("setHasPrompts", []);
    this.load();
  },
  created() {
    if (this.$route.query && this.$route.query.groupby) {
      this.groupBy = this.$route.query.groupby;
    }
    this.loadFandomBookmarksAndPromptmarks();
  },
  directives: {
    tableResizer
  },
  data() {
    return {
      allOptions: [],
      scraperRes: undefined,
      scraperLoading: false,
      processing: false,
      status: {},
      open: true,
      showHelp: false,
      down: {},
      mods: false,
      filter: "",
      filtered: [],
      updating: true,
      sticky: false,
      promptStates: {},
      pagination: {
        first: 0,
        last: 100,
        size: 100,
        total: 0
      },
      groupComponent: AggregatedFandomTable,
      controller: undefined,
      groupBy: "Creator's Choice of Previously Requested Fandom",
      groupByOptions: [
        { display: 'CCOPRF', tag: "Creator's Choice of Previously Requested Fandom" },
        { display: 'AFIRB', tag: "Any Fandom I've Requested Before" },
      ]
    };
  },
  computed: {
    ...mapGetters([
      "exchangeId",
      "isExchangeOpen",
      "bookmarks",
      "categories",
      "characters",
      "fandoms",
      "hasPrompts",
      "letters",
      "loadAll",
      "loaded",
      "options",
      "promptmarks",
      "prompts",
      "user"
    ]),
    marksCount() {
      let count = 0;
      if (this.bookmarks && this.bookmarks.length) {
        count += this.bookmarks.length;
      }
      if (this.promptmarks && this.promptmarks.length) {
        count += this.promptmarks.length;
      }

      return count;
    }
  },
  watch: {
    $route(to) {
      if (to.name === "aggregated" || to.name == "ccof") {
        if (this.$route.query && this.$route.query.groupby) {
          this.groupBy = this.$route.query.groupby;
        }
        this.$store.commit("setPrompts", {});
        this.$store.commit("setAggregatedPrompts", {});
        this.$store.commit("setFandoms", []);
        this.$store.commit("setTimestamp", null);
        this.$store.commit("setHasPrompts", []);
        this.$store.commit("setExchangeId", this.$route.params.exchangeId);

        this.load();
      }
    },
    exchangeId(val) {
      if (this.$route.params.exchangeId != val) {
        this.$router.replace({
          name: this.$route.name,
          params: {
            exchangeId: val
          }
        });
      }
      const newOptions = this.$store.state.options;
      this.$store.commit("setOptions", newOptions);
      this.load();
    },
    groupBy(newVal, oldVal) {
      if (newVal == oldVal) return;

      if (this.$route.query && this.$route.query.groupby != newVal) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            groupby: newVal
          }
        });
      }
      this.load();
    },
    allOptions() {
      this.pagination.first = 0;
      this.pagination.last = this.pagination.size;
      this.updateFilter();
    },
    // Deep watching doesn't work
    "filter": function () {
      this.updateFilter(true);
    },
    "options.onlyBookmarks": function () {
      this.updateFilter(true);
    },
  },
  methods: {
    ...utils,
    load() {
      this.status = {};
      this.scraperRes = undefined;
      this.processing = false;
      this.$store.commit("setCharsLoaded", false);
      this.$store.commit("setDbLoaded", false);

      const exchangeId = this.$route.params.exchangeId;
      this.$store.commit("setExchangeId", this.$route.params.exchangeId);

      // exchange metadata
      axios.get(`https://autoao3.herokuapp.com/db/exchanges/${exchangeId}/status`).then((res) => {
        if (res.data && res.data.status != "open" && res.data.status != "complete") {
          this.processing = true;
          this.status = res.data;
        }
        this.$store.commit("setTimestamp", res.data.scraped);

        this.$store.commit("setIsExchangeOpen", res.data && res.data.status == "open");
      });

      this.loadFandoms();
      this.loadFandomBookmarksAndPromptmarks();
    },
    async loadFandoms() {
      this.groupComponent = AggregatedFandomTable;

      await axios
        .get(`https://autoao3.herokuapp.com/db/exchanges/${this.exchangeId}/aggregate/${this.groupBy}/fandoms`)
        .then((res) => {

          const withIndex = map(res.data, o => {
            return {
              name: o,
              index: o.hashCode()
            }
          })

          this.$store.commit("setFandoms", withIndex);
          this.allOptions = withIndex;
        });

      if (!this.loaded) {
        this.$store.commit("setDbLoaded", true);
      }

    },
    updateFilter(resetPagination) {
      this.updating = true;
      this.filtered = this.allOptions;

      if (resetPagination) {
        this.pagination.first = 0;
        this.pagination.last = this.pagination.size;
      }

      // Do not let pagination go below 0
      if (this.pagination.first < 0) {
        this.pagination.first = 0;
      }

      // Remove tags that have no names

      let arr = this.allOptions;
      arr = filter(arr, (f) => {
        return f.name ? f.name.length : f.length;
      });

      // Case: no filters
      // Show all fandoms, slicing by pagination
      if (
        !this.filter.length &&
        !this.options.onlyBookmarks
      ) {
        this.filtered = slice(
          arr,
          this.pagination.first,
          this.pagination.last
        );

        this.pagination.total = arr.length;

        setTimeout(() => {
          this.updating = false;
        }, 150);

        return;
      }

      // Case: apply filters

      if (this.options.onlyBookmarks) {
        const bookmarkedFandoms = [];
        each(this.bookmarks, (b) => {
          bookmarkedFandoms.push(b.name);
        });

        arr = filter(arr, (o) => {
          return includes(bookmarkedFandoms, o.name);
        });
      }

      if (this.filter.length) {
        arr = filter(arr, (o) => {
          const name = o.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          return name.indexOf(this.filter.toLowerCase()) > -1;
        });
      }

      // Set pagination.last if the filtered array ends up being smaller
      // or if loadAll is turned on
      if (arr.length < this.pagination.last) {
        this.pagination.last = arr.length;
      }

      // Otherwise, sort by category before slicing
      this.filtered = slice(
        arr,
        this.pagination.first,
        this.pagination.last
      );
      this.pagination.total = arr.length;

      setTimeout(() => {
        this.updating = false;
      }, 100);
    },
    async page(start) {
      this.pagination.last = start + this.pagination.size;
      this.pagination.first = start;
      this.updateFilter();
    },
    scrollToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    process() {
      this.scraperLoading = true;
      axios
        .get(`https://autoao3.herokuapp.com/scrape/${this.exchangeId}`)
        .then((res) => {
          this.scraperRes = res;
          this.scraperLoading = false;
        })
        .catch((e) => {
          if (e.response) {
            this.scraperRes = e.response;
            this.scraperLoading = false;
            return;
          }
          this.scraperRes = {
            error: true,
            e: e,
            msg: "Something went wrong! Report a bug."
          };
          this.scraperLoading = false;
        });
    }
  }
};
</script>

<style lang="scss">
@import "../styles/app.scss";
@import "../styles/mobile.scss";

.text-small {
  font-size: 80%;
}
</style>
